import moment from 'moment'
import { Histograma } from '../../../models/productividad/histograma'

import {
  TABLA_HISTOGRAMA_VOLCADORA,
  TABLA_HISTOGRAMA_INGRESO_POR_CEREAL,
  TABLA_HISTOGRAMA_INGRESO_POR_USUARIO,
  TABLA_HISTOGRAMA_CALADO_POR_PUESTO,
  TABLA_HISTOGRAMA_BALANZAS
} from '../../../config/tables'
import {
  COLUMNS_HISTOGRAMA_VOLCADORA,
  COLUMNS_HISTOGRAMA_INGRESO_POR_CEREAL,
  COLUMNS_HISTOGRAMA_CALADO_POR_PUESTO,
  COLUMNS_HISTOGRAMA_BALANZAS,
  COLUMNS_HISTOGRAMA_INGRESO_POR_USUARIO
} from './constantesHistograma'
import DemoraVolcadora from '../../../models/volcadora/demora_volcadora'

export function parseData (data) {
  const parsedData = []
  data.filas_procesadas > 0 && data.filas.map((entry) => {
    return parsedData.push({ ...entry })
  })
  return parsedData
}

export function parseDataBalanzas (data) {
  const parsedData = []
  data[0] && data[0].filas_procesadas > 0 && data[0].filas.map((entry) => {
    return parsedData.push({ ...entry, balanza: entry.balanzaDeBruto })
  })
  data[1] && data[1].filas_procesadas > 0 && data[1].filas.map((entry) => {
    return parsedData.push({ ...entry, balanza: entry.balanzaDeDestare })
  })
  return parsedData
}

export function parseDataVolcadoras (data, demoras) {
  const parsedData = []
  if (data && data.filas_procesadas > 0) {
    data.filas.map((d) => {
      const demoraVolcadora = demoras.filter((dem) => dem.volcadoraCamiones === d.volcadoraCamiones &&
                                                      d.fecha === moment(dem.inicioDeDemora).format('YYYY-MM-DD')
      )
      const entry = ({
        ...d,
        fecha: d.fecha,
        volcadora: d.volcadoraCamiones,
        demoras: demoraVolcadora
      })
      return parsedData.push({ ...d, entry: entry })
    })
  }
  return parsedData
}

export function actualizarHistogramaVolcadoras (fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_HISTOGRAMA_VOLCADORA
    })
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    Promise.all([
      Histograma.getHistogramaVolcadora(fechaD, fechaH),
      DemoraVolcadora.getDemoraVolcadora(fechaD, fechaH)
    ])
      .then(([d, demoras]) => {
        const data = parseDataVolcadoras(d, demoras)
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_HISTOGRAMA_VOLCADORA,
            data: data,
            title: 'Volcado por volcadora',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar: null,
              download: false,
              pagination: false,
              search: false,
              print: false,
              filter: false,
              viewColumns: false,
              tableBodyMaxHeight: '450px'
            }
          },
          id: TABLA_HISTOGRAMA_VOLCADORA
        })
      })
  }
}

export function actualizarHistogramaIngresoPorCereal (fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_HISTOGRAMA_INGRESO_POR_CEREAL
    })
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    Histograma.getHistogramaIngresoPorCereal(fechaD, fechaH).then(callback)
    async function callback (d) {
      const data = parseData(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_HISTOGRAMA_INGRESO_POR_CEREAL,
          data: data,
          title: 'Ingreso por cereal',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar: null,
            download: false,
            pagination: false,
            search: false,
            print: false,
            filter: false,
            viewColumns: false,
            tableBodyMaxHeight: '450px'
          }
        },
        id: TABLA_HISTOGRAMA_INGRESO_POR_CEREAL
      })
    }
  }
}

export function actualizarHistogramaIngresoPorUsuario (fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_HISTOGRAMA_INGRESO_POR_USUARIO
    })
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    Histograma.getHistogramaIngresoPorUsuario(fechaD, fechaH).then(callback)
    async function callback (d) {
      const data = parseData(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_HISTOGRAMA_INGRESO_POR_USUARIO,
          data: data,
          title: 'Ingreso por usuario',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar: null,
            download: false,
            pagination: false,
            search: false,
            print: false,
            filter: false,
            viewColumns: false,
            tableBodyMaxHeight: '450px'
          }
        },
        id: TABLA_HISTOGRAMA_INGRESO_POR_USUARIO
      })
    }
  }
}

export function actualizarHistogramaCaladoPorPuesto (fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_HISTOGRAMA_CALADO_POR_PUESTO
    })
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    Histograma.getHistogramaCalado(fechaD, fechaH).then(callback)
    async function callback (d) {
      const data = parseData(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_HISTOGRAMA_CALADO_POR_PUESTO,
          data: data,
          title: 'Calado por puesto',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar: null,
            download: false,
            pagination: false,
            search: false,
            print: false,
            filter: false,
            viewColumns: false,
            tableBodyMaxHeight: '450px'
          }
        },
        id: TABLA_HISTOGRAMA_CALADO_POR_PUESTO
      })
    }
  }
}

export function actualizarHistogramBalanzas (fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_HISTOGRAMA_BALANZAS
    })
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    Promise.all([
      Histograma.getHistogramaBalanzaBruto(fechaD, fechaD),
      Histograma.getHistogramaBalanzaDestare(fechaD, fechaH)
    ])
      .then(callback)
    async function callback (d) {
      const data = parseDataBalanzas(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_HISTOGRAMA_BALANZAS,
          data: data,
          title: 'Pesado en balanzas',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar: null,
            download: false,
            pagination: false,
            search: false,
            print: false,
            filter: false,
            viewColumns: false,
            tableBodyMaxHeight: '450px'
          }
        },
        id: TABLA_HISTOGRAMA_BALANZAS
      })
    }
  }
}

export function actualizarHistogramas (fechaD, fechaH) {
  return (dispatch) => {
    dispatch(actualizarHistogramaVolcadoras(fechaD, fechaH))
    dispatch(actualizarHistogramaIngresoPorCereal(fechaD, fechaH))
    dispatch(actualizarHistogramaIngresoPorUsuario(fechaD, fechaH))
    dispatch(actualizarHistogramaCaladoPorPuesto(fechaD, fechaH))
    dispatch(actualizarHistogramBalanzas(fechaD, fechaH))
  }
}

export function actualizarHistogramasCDMD (fechaD, fechaH) {
  return (dispatch) => {
    dispatch(actualizarHistogramaVolcadoras(fechaD, fechaH))
    dispatch(actualizarHistogramaIngresoPorCereal(fechaD, fechaH))
    dispatch(actualizarHistogramaCaladoPorPuesto(fechaD, fechaH))
  }
}
